// extracted by mini-css-extract-plugin
module.exports = {"logo":"_25j943v0oLCKM3besGeRBb","info_title":"_2WrDK0tzBsBg7dyVRkKfO8","continue_text":"_2J-sS6CbG_MZXwYd4shMqN","link_button":"_3qcbf27bojWaNU9UhuA9Bw"};